import { render, staticRenderFns } from "./IndicatorSettings.vue?vue&type=template&id=4852748f&scoped=true"
import script from "./IndicatorSettings.vue?vue&type=script&lang=js"
export * from "./IndicatorSettings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4852748f",
  null
  
)

export default component.exports